import React, {useMemo} from "react"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import {makeStyles} from "@material-ui/core/styles"
import {Dialog, Typography, Button} from "@material-ui/core"
import {useStore, useDispatch} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import {nl2br} from "../common"
import TrendingUpIcon from "@material-ui/icons/TrendingUp"
import TrendingDownIcon from "@material-ui/icons/TrendingDown"
import {pink, green} from "@material-ui/core/colors"

const useStyles = makeStyles((theme) => ({
  root: {
    display: `flex`,
    flexDirection: `row`,
    flexWrap: `wrap`,
    justifyContent: `center`,
    width: `100%`,
    zIndex: 100000000000,
  },
  typo: {
    [theme.breakpoints.down(`sm`)]: {
      fontSize: `0.75rem`,
    },
  },
  up: {
    color: pink.A400,
    [theme.breakpoints.up(`md`)]: {
      fontSize: (props) => (props.locale === `ja` ? `1.5rem` : `1.25rem`),
    },
  },
  down: {
    color: green.A700,
    [theme.breakpoints.up(`md`)]: {
      fontSize: (props) => (props.locale === `ja` ? `1.5rem` : `1.25rem`),
    },
  },
}))

export default function ConfirmDialog() {
  const {t} = useTranslation()
  const {
    store: {confirmDialog, locale},
  } = useStore()
  const classes = useStyles({
    locale,
  })
  const {title = t(`confirmDialog`), message = ``, error = ``, state = false, content = ``, result = null} = confirmDialog
  const {dispatch} = useDispatch()

  const handleClose = () => {
    const type = `CONFIRM_DIALOG`
    dispatch({
      type,
      confirmDialog: {
        ...confirmDialog,
        state: false,
      },
    })
  }

  const forecast = useMemo(() => {
    if (result === null) return null
    return result ? (
      <Typography className={classes.up} key={`up`}>
        <TrendingUpIcon
          style={{
            fontSize: `8em`,
            display: `flex`,
          }}
        />
        {nl2br(content)}
      </Typography>
    ) : (
      <Typography className={classes.down} key={`down`}>
        <TrendingDownIcon
          style={{
            fontSize: `8em`,
            display: `flex`,
          }}
        />
        {nl2br(content)}
      </Typography>
    )
  }, [content, classes])

  return useMemo(
    () => (
      <Dialog
        open={state}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.root}>{nl2br(title)}</DialogTitle>
        <DialogContent className={classes.root}>
          <Typography className={classes.typo}>{nl2br(message)}</Typography>
          <br />
          {forecast}
          <Typography className={classes.typo}>{error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{nl2br(t(`closeButton`))}</Button>
        </DialogActions>
      </Dialog>
    ),
    [classes, confirmDialog, locale],
  )
}
